import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, PropType } from "vue"
import { Section } from "@/components/forms/SurveyEditor.vue"
type Form = {
  title: string
  description?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveySection',
  props: {
  section: {
    type: Object as PropType<Section>,
    required: true,
  },
  surveyId: {
    type: String,
    required: true,
  },
},
  emits: ["saving", "saved", "error", "addSection", "updateSection"],
  setup(__props, { emit }) {

const props = __props




const descriptionInputError = ref(false)
const titleInputError = ref(false)

const form = ref<Form>({
  title: "",
  description: "",
})

watch(
  props.section,
  () => {
    form.value.title = props.section.title
    form.value.description = props.section.description
  },
  {
    deep: true,
    immediate: true,
  }
)

const onSave = (payload: { title?: string; description?: string }) => {
  if (props.section.id) {
    emit("updateSection", { ...payload, id: props.section.id })
  } else {
    emit("addSection", { ...payload, surveyId: props.surveyId })
  }
}

const onTitleChange = () => {
  if (!form.value.title) return (titleInputError.value = true)
  onSave({
    title: form.value.title,
  })
}

const onDescriptionChange = () => {
  if (!form.value.description) return (descriptionInputError.value = true)
  onSave({
    description: form.value.description,
  })
}

return { __sfc: true,props, emit, descriptionInputError, titleInputError, form, onSave, onTitleChange, onDescriptionChange }
}

})